// relative
import { energyAnalysisApiSlice } from '../apiSlice';

export const utilityProviderSlice = energyAnalysisApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUtilityProviders: builder.query({
      query: ({ utility_type }) => ({
        url: `/utility_providers/${utility_type}`,
        method: 'GET',
      }),
      providesTags: ['UtilityProviders'],
    }),
    getConfigurableUtilityProviders: builder.query({
      query: ({ utility_type }) => ({
        url: `/configurable_utility_providers/${utility_type}`,
        method: 'GET',
      }),
      providesTags: ['UtilityProviders'],
    }),
    getUtilityProviderCoefficients: builder.query({
      query: ({ utility_type, provider_id }) => ({
        url: `/utility_provider_coefficients/${utility_type}/${provider_id}`,
        method: 'GET',
      }),
      providesTags: ['UtilityProviderCoefficients'],
    }),
    setUtilityProviderCoefficient: builder.mutation({
      query: ({ utility_type, body }) => ({
        url: `/utility_provider_coefficient/${utility_type}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['UtilityProviders', 'UtilityProviderCoefficients'],
    }),
    deleteUtilityProviderCoefficient: builder.mutation({
      query: ({ utility_type, provider_id, coefficient_id }) => ({
        url: `/utility_provider_coefficient/${utility_type}/${provider_id}/${coefficient_id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['UtilityProviders', 'UtilityProviderCoefficients'],
    }),
    setMeterUtilityProvider: builder.mutation({
      query: ({
        analysis_type,
        account_id,
        meter_id,
        utility_provider_id,
      }) => ({
        url: `/meter_utility_provider/${analysis_type}/${account_id}/${meter_id}?utility_provider_id=${utility_provider_id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['PortfolioAnalysis'],
    }),
  }),
});

export const {
  useGetUtilityProvidersQuery,
  useGetConfigurableUtilityProvidersQuery,
  useGetUtilityProviderCoefficientsQuery,
  useSetUtilityProviderCoefficientMutation,
  useDeleteUtilityProviderCoefficientMutation,
  useSetMeterUtilityProviderMutation,
} = utilityProviderSlice;
